import React, { useEffect, useMemo, useState } from "react";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import VoiceOptions from "./VoiceOptions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getVoiceFromValue } from "../../../../constants/scriptConfig";
import {
  setUserVoice,
  updateGeneratedVoice,
  updateSlideOriginalScript,
  updateSlideVoiceFile,
} from "../../../../store/slides/slidesSlice";
import { showToast } from "../../../../utils/general";
import { closePopover } from "../../../../store/common/uiSlice";
import { Tooltip } from "../../Tooltip";
import VoiceCard from "../../VoiceCard";

const TextScript = ({
  voiceSelectorVisible,
  setVoiceSelectorVisible,
  setShowSubtitle,
  voiceOptionClassName,
}) => {
  const voiceOptions = []; // Fill this array with your actual options
  const { slides, currentSlideIndex } = useSelector((state) => state.slides);
  const dispatch = useDispatch();
  const { trial, isAdmin } = useSelector((state) => state?.user);
  const { isFaceless, isDoc, isLinkVideo, isOnlyAIVoice } = useSelector(
    (state) => state?.project
  );

  const isonlyavtar = window.location.pathname.includes("only-avatar");
  const currentSlide = useMemo(
    () => slides[currentSlideIndex],
    [currentSlideIndex, slides]
  );
  const isDidAvatar = currentSlide?.objects?.some((slide) => {
    return slide.type === "avatar" && slide.url.includes("d-id");
  });
  const avatar = useMemo(() => {
    const avatar = (currentSlide?.objects || []).find(
      (obj) => obj.type === "avatar"
    );
    return avatar;
  }, [currentSlide]);

  const charLimit = useMemo(() => {
    if (trial) return 200;
    if (trial && isFaceless) return 200;
    if (isonlyavtar) return 1000; // Only avatar
    if (isDoc || isLinkVideo) return 800; // Docs to video / Link to video
    if (isOnlyAIVoice) return 1500; // Just AI voice
    return 800; // Normal / Faceless
  }, [isDidAvatar, isDoc, isLinkVideo, isOnlyAIVoice]);

  // const minimumCharcter = useMemo(() => {
  //   if(isOnlyAIVoice) return 100
  // },[isDidAvatar, isDoc, isLinkVideo, isOnlyAIVoice])

  // console.log("isOnlyAIVoice",isOnlyAIVoice);

  const limitExceeded = useMemo(
    () =>
      (!isAdmin || isDoc || isLinkVideo) &&
      (currentSlide?.originalScript || "").length > charLimit,
    [currentSlide?.originalScript, isAdmin, isDoc, isLinkVideo, charLimit]
  );

  const dynamicValue = `${
    currentSlide?.originalScript?.length || 0
  } / ${charLimit}`;

  const avatarGenderVoiceMismatch = useMemo(() => {
    if (isFaceless) {
      return false;
    }
    const voiceGender = getVoiceFromValue(currentSlide?.voice)?.gender;
    const voiceMismatch =
      voiceGender &&
      (avatar?.gender || "").toLowerCase() !== voiceGender.toLowerCase();
    return voiceMismatch;
  }, [currentSlide?.voice, avatar, isFaceless]);

  const getLimitExceededMessage = () => {
    if (trial) {
      return "Max 150 Characters allowed in free trial";
    } else if (isDidAvatar) {
      return (
        <div className="text-vb-violet">
          Max 1000 Characters allowed.
          <p>
            In order to ensure stability of the system, the character limit will
            gradually increase. Please be rest assured.
          </p>
        </div>
      );
    } else if (isOnlyAIVoice) {
      return "Max 1500 Characters allowed";
    } else {
      return "Max 800 Characters allowed";
    }
  };

  useEffect(() => {
    if (!currentSlide?.originalScript && currentSlide?.script) {
      dispatch(updateSlideOriginalScript(currentSlide?.script));
    }
  }, []);

  const onConfirmScript = () => {
    showToast("Script added to slide");

    dispatch(setUserVoice(false));
    dispatch(updateSlideVoiceFile(currentSlide.generatedVoice));
    return dispatch(closePopover());
  };

  const handleBlur = (event) => {
    const { value } = event.target;
    if (limitExceeded) {
      return;
    }
    dispatch(updateGeneratedVoice(null));
    dispatch(updateSlideVoiceFile(null));
  };

  return voiceSelectorVisible ? (
    <div className="h-full">
      <VoiceOptions
        onClose={async () => {
          return setVoiceSelectorVisible(false);
        }}
        voiceOptionClassName={voiceOptionClassName}
      />
      {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {voiceOptions.map((option) => (
          <VoiceOptionCard key={option.name} {...option} />
        ))}
      </div> */}
    </div>
  ) : (
    <div className=" ">
      <label
        htmlFor="scriptInput"
        className="block mb-2 text-sm font-semibold text-gray-700"
      >
        Enter your Script For{" "}
        <span className="text-primary-blue">Slide {currentSlideIndex + 1}</span>
      </label>

      <div className="mb-2">
        <div style={{ position: "relative", width: "100%" }}>
          <textarea
            key="scriptInput"
            rows="4"
            value={currentSlide?.originalScript}
            defaultValue={currentSlide?.originalScript}
            onChange={(e) =>
              dispatch(updateSlideOriginalScript(e.target.value))
            }
            maxLength={charLimit}
            // minLength={minimumCharcter}
            onBlur={handleBlur}
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            placeholder="Welcome to the new era of video creation with vidBoard!"
            style={{ height: "150px", resize: "none", overflowY: "auto" }}
          />
          {!isAdmin && (
            <div
              style={{
                position: "absolute",
                bottom: "8px",
                right: "8px",
                color: "inherit",
                fontSize: "12px",
              }}
            >
              {dynamicValue}
            </div>
          )}
        </div>
        {limitExceeded && (
          <p className="text-xs text-red-500">{getLimitExceededMessage()}</p>
        )}
      </div>
      <VoiceCard
        mismatchedVoiceAvatar={avatarGenderVoiceMismatch}
        setVoiceSelectorVisible={setVoiceSelectorVisible}
      />
      <div className="mt-4">
        {/* <div className="flex lg:flex justify-between items-center gap-2"> */}
        <div className="flex justify-end items-center">
          <button
            className={` ${
              !currentSlide.generatedVoice?.mp3 ||
              avatarGenderVoiceMismatch ||
              limitExceeded
                ? "bg-gray-600 cursor-not-allowed"
                : ""
            } relative inline-flex items-center  lg:mt-0 xl:mt-0 px-1 xl:px-4 py-2 border border-transparent text-xs lg:text-[10px] xl:text-sm font-medium rounded-md shadow-sm text-white bg-black hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 group`}
            onClick={() => onConfirmScript()}
            disabled={
              !currentSlide.generatedVoice?.mp3 ||
              avatarGenderVoiceMismatch ||
              limitExceeded
            }
          >
            Use Script & Voice
            {(!currentSlide.generatedVoice?.mp3 ||
              avatarGenderVoiceMismatch) && (
              <Tooltip>
                {avatarGenderVoiceMismatch
                  ? "Selected avatar gender & voice are not match"
                  : "Please generate the voice.!"}
              </Tooltip>
            )}
          </button>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default TextScript;
